import script from "./OrderDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderDetail.vue?vue&type=script&lang=ts&setup=true"

import "./OrderDetail.vue?vue&type=style&index=0&id=22c64ea0&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22c64ea0"]])

export default __exports__